import React, { Component } from "react";
import { BlueBtn } from "components/Controls";
import { connect } from "react-redux";
import { selectOffer, nextStep } from "../../actions";
import { mergeRight } from "ramda";
import { BuyoutInfo, OfferView } from "components/DataDisplay";
import PropTypes from "prop-types";
import {change, Field, reduxForm} from 'redux-form';
import { AnalyticAPI } from "api/analytic";
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import {
  appRequestSelector,
  trendingsVisitID,
} from "../../selectors";
import { createStructuredSelector } from "reselect";
import OfferHeader from "../OfferHeader";
import { buildOfferData } from "containers/MultistepForm/helpers";
import {addThousandsSeparator, paymentFrequency} from 'utils/helpers';

import "./styles.scss";
import {RadioField} from '../../../../components/Fields';
import OfferBlock from '../../../../components/DataDisplay/OfferBlock';

class CreditkeyOffer extends Component {
  state = {
    loading: false,
    selectedOffer: null,
    options: [],
  };

  componentDidMount = () => {
    const { offer } = this.props;

    const sortedOptions = offer.options.sort((a, b) => {
      return a.payment_period - b.payment_period;
    });

    this.setState({
      options: sortedOptions,
    });

    const defaultSelected = offer.options[offer.options.length - 1];
    if (offer.options.length > 1) {
      this.props.dispatch(
        change(
          "form",
          `${offer.specific_provider_name}paymentPeriod`,
          defaultSelected.payment_period.toString()
        )
      );
    }
    this.setSelected(defaultSelected);
  };

  setSelected = (option) => {
    const { offer } = this.props;

    option = mergeRight(option, {
      app_id: offer.app_id,
      lease_app_id: offer.lease_app_id,
      provider: offer.provider,
      payment_schedule: offer.payment_schedule,
      approved_amount: offer.approved_amount,
      specific_provider_name: offer.provider,
      cart_total: offer.cart_total,
      bank_data_is_required: true,
    });
    this.props.getSelectedOffer(option);
    this.setState({ selectedOption: option });
  };

  submitForm = (values) => {
    const { selectOffer, logContinueEvent } = this.props;
    const { selectedOption } = this.state;

    const { token, visitID } = this.props;
    AnalyticAPI.send_provider_analytic_event(
      token,
      "select_provider",
      "creditkey",
      visitID
    );
    logContinueEvent()
    this.setState({ loading: true });
    selectOffer({ selectedOffer: selectedOption, body: { offer_id: selectedOption.offer_id } });
  };

  renderEarlyOptions = () => {
    return (
      <div>
        <div className='second-buyoutinfo'>
          <BuyoutInfo
            title={'Early Buyout Option'}
            text={`Pay off your account early any time`}
          />
        </div>
      </div>
    )
  }


  paymentPeriodOptions = () => {
    const { offer } = this.props;

    return offer.options.map((option) => {
      return {
        value: `${option.payment_period.toString()} Months`,
        key: option.payment_period.toString(),
      };
    });
  };

  renderPaymentPeriodField = ({ input, meta }) => {
    return (
      <RadioField
        {...input}
        meta={meta}
        options={this.paymentPeriodOptions()}
        customChange={this.setPaymentPeriod}
      />
    );
  };

  setPaymentPeriod = (value) => {
    const option = this.props.offer.options.find(
      (option) => option.payment_period === parseInt(value)
    );

    this.setSelected(option);
  };

  renderPaymentPeriodBlock = () => {
    const { offer } = this.props;
    const { selectedOption } = this.state;

    if (offer.options.length === 1) {
      return <OfferBlock
        row={[{
          title: 'Payment Period',
          value: `${selectedOption.payment_period} Months`
        }]}
      />
    } else {
      return (
        <div className="offer-block offer-block--100">
          <div className="offer-item offer-item__column block-padding">
            <div className="offer-item__title">Payment Period:</div>
            <Field
              name={`${offer.specific_provider_name}paymentPeriod`}
              component={this.renderPaymentPeriodField}
            />
          </div>
        </div>
      )
    }
  }

  renderHeaderPaymentPeriod = () => {
    const { selectedOption } = this.state
    const { offer } = this.props

    if (offer.options.length === 1) {
      return (`${selectedOption.payment_period} Months`)
    } else {
      return (`up to ${selectedOption.payment_period} Months`)
    }
  }


  render() {
    const { loading, selectedOption } = this.state;
    const { handleSubmit, valid, available, isExpanded, offer, appRequest } =
      this.props;

    if (!selectedOption) {
      return "";
    }

    return (
      <div className="expanded-block-component__expanded-content">
        <OfferHeader
          available={available}
          isExpanded={isExpanded}
          dueToday={addThousandsSeparator(selectedOption.initial_payment)}
          specificProviderName={offer.specific_provider_name}
          paymentPeriod={`${this.renderHeaderPaymentPeriod()}`}
          paymentFrequency={paymentFrequency(selectedOption)}
          approvedAmount={offer.approved_amount}
          typeOfPlan={selectedOption.type}
        />
        {isExpanded && (
          <form
            onSubmit={handleSubmit(this.submitForm)}
            className="creditkey-offer application-offer"
          >
            <div className="step3__recommended-offer-plan offer-plan__top flex flex--wrap">
              <OfferView offerData={buildOfferData(selectedOption, false, false, '')}  />
              {this.renderPaymentPeriodBlock()}
              <OfferView offerData={buildOfferData(selectedOption, false, true, '')}  />

            </div>
            {this.renderEarlyOptions()}
            <BlueBtn
              customClass="step3__recommended-content-btn"
              loading={loading}
              disabled={!available || !valid}
              type="submit"
            >
              Continue with Creditkey
            </BlueBtn>
          </form>
        )}
      </div>
    );
  }
}

CreditkeyOffer.propTypes = {
  offer: PropTypes.object.isRequired,
  available: PropTypes.bool,
};

CreditkeyOffer.defaultProps = {
  available: true,
};

const mapStateToProps = createStructuredSelector({
  token: tokenSelector(),
  appRequest: appRequestSelector(),
  visitID: trendingsVisitID(),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
    nextStep: (value) => dispatch(nextStep(value)),
  };
};

CreditkeyOffer = connect(mapStateToProps, mapDistpatchToProps)(CreditkeyOffer);

CreditkeyOffer = reduxForm({
  form: "form",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(CreditkeyOffer);

export default CreditkeyOffer;
